<template>
  <div>
    <div v-if="!loading">
      <v-row>
        <v-col>
          <v-btn
            dark
            color="white"
            outlined
            small
            @click="backToInvitationList"
          >
            <span>{{ $t('eventPage.backToInvitationList') }}</span>
          </v-btn>
        </v-col>
      </v-row>
      <v-row class="mb-2">
        <v-col>
          <span class="text-h3">
            {{ invitation.guest.first_name }} {{ invitation.guest.last_name }}
          </span>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-tabs
            v-model="userTab"
            show-arrows
            color="primary"
          >
            <v-tab
              v-for="tab in tabs"
              :key="tab.icon"
            >
              <v-icon
                size="20"
                class="me-3"
              >
                {{ tab.icon }}
              </v-icon>
              <span>{{ tab.title }}</span>
            </v-tab>
          </v-tabs>

          <v-tabs-items
            v-model="userTab"
            class="mt-5"
            style="background-color: transparent;"
          >
            <v-tab-item style="background-color: transparent;">
              <OverviewTab :invitation-data="invitation" />
            </v-tab-item>
          </v-tabs-items>
        </v-col>
      </v-row>
    </div>
    <v-overlay :value="loading">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import { getCurrentInstance, ref } from '@vue/composition-api';
import { fetchInvitation } from '@/services/invitations/invitations.service';
import { useRouter } from '@core/utils';
import { ERROR_404, EVENT_PAGE } from '@/router/constants';
import { mdiChevronLeft, mdiCardSearchOutline } from '@mdi/js';
import OverviewTab from './Tabs/Overview.vue';

export default {
  name: 'EventPageInvitation',
  components: { OverviewTab },
  setup() {
    const vm = getCurrentInstance().proxy;
    const { invitationId, eventId } = vm.$route.params;
    const { router } = useRouter();

    // State
    const loading = ref(true);
    const userTab = ref(null);
    const tabs = ref([{ icon: mdiCardSearchOutline, title: 'Overview' }]);

    // State
    const invitation = ref(false);

    // Methods

    const getInvitation = async () => {
      try {
        invitation.value = await fetchInvitation(invitationId);
        loading.value = false;
      } catch (e) {
        loading.value = true;
        router.push({ name: ERROR_404 });
      }
    };

    const backToInvitationList = () => {
      router.push({ name: EVENT_PAGE, params: { eventId } });
    };

    // Created
    getInvitation();

    // Return

    return {
      // State
      invitation,
      loading,
      tabs,
      userTab,

      // Methods
      backToInvitationList,

      // Others
      icons: {
        mdiChevronLeft,
      },
    };
  },
};
</script>
